module.exports = __webpack_public_path__ + "static/media/ss-dial-padder.3e9cff28.png";